import { BarChart, Handshake, Coins, Building2, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ServiceCard from '../components/ServiceCard';
import { useCMS, pickLoc } from '../context/CMSContext';
import { useSeo, breadcrumb } from '../lib/seo';

const Services = () => {
  const { t } = useTranslation();
  const { cms, lang } = useCMS();

  const services = [
    {
      id: 'ipo',
      icon: <BarChart className="h-8 w-8" />,
      link: '/contact'
    },
    {
      id: 'ma',
      icon: <Handshake className="h-8 w-8" />,
      link: '/contact'
    },
    {
      id: 'corpFin',
      icon: <Coins className="h-8 w-8" />,
      link: '/contact'
    },
    {
      id: 'corpStruct',
      icon: <Building2 className="h-8 w-8" />,
      link: '/contact'
    },
    {
      id: 'opsMgmt',
      icon: <Settings className="h-8 w-8" />,
      link: '/contact'
    }
  ];

  const seo = cms.seo.pages.services;

  useSeo({
    title: pickLoc(seo.title, lang),
    description: pickLoc(seo.description, lang),
    keywords: pickLoc(seo.keywords, lang),
    path: '/services',
    jsonLd: [
      breadcrumb([
        { name: '首頁', path: '/' },
        { name: t('services.title'), path: '/services' },
      ]),
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: `${cms.site.orgNameEn} Services`,
        itemListElement: services.map((s, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          item: {
            '@type': 'Service',
            name: t(`services.${s.id}.title`),
            description: t(`services.${s.id}.desc`),
            provider: {
              '@type': 'ProfessionalService',
              name: cms.site.orgNameTc,
              alternateName: cms.site.orgNameEn,
            },
            areaServed: ['HK', 'CN', 'Asia-Pacific'],
          },
        })),
      },
    ],
  });

  return (
    <div className="bg-gray-50 min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6 font-serif">{t('services.title')}</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              title={t(`services.${service.id}.title`)}
              tagline={t(`services.${service.id}.tagline`)}
              description={t(`services.${service.id}.desc`)}
              link={service.link}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
